export default __webpack_public_path__ + "static/media/wedding-cz-logo.b5fbf145.svg";